import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import {  GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { ComunidadService, PedidoService } from '../../../../../src/app/shared/services';
import { MenuFuncionService } from '../../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, Pedido, SearchPedidoRequestDto, SearchTipoMaterialRequest, TipoMaterialDto, PedidoDto, Comunidad, SearchComunidadRequest,  SearchEstadoRequest, Estado, EstadoConstants } from '../../../../../src/app/shared/model';
import { TipoMaterialService } from '../../../../../src/app/shared/services/tipo-materiales.service';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';
import { ExportMediaTypeConstants } from '../../../shared/model';

@Component({
  selector: 'app-compras',
  templateUrl: './compras.component.html',
  styleUrls: ['./compras.component.scss']
})
export class ComprasComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;
  public data: DataManager;
  isValidating: boolean = false;
  isSearching: boolean = false;
  isTipoMaterialSearching: boolean = false;
  isExporting: boolean = false;
  isTipoSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isEstadoSearching: boolean  = false;
  canEdit: boolean = false;
  canView: boolean = false;
  verSoloActivos: boolean = true;
  filteredComunidadesList: Comunidad[];
  tipoMaterialList: TipoMaterialDto[]=[];
  estadoList: Estado[];
  total: number = 0;
  searchForm: FormGroup;
  item: PedidoDto;

  filtroFacturadoList: any[] = [
    { Id: 0, Nombre: "Ver todos" },
    { Id: 1, Nombre: "Ver solo pedidos pagados" },
    { Id: 2, Nombre: "Ver solo pedidos sin pagar" }
  ];

  public query: Query;
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    public sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder,
    private router: Router,
    private menuService: MenuFuncionService,
    private tipoMaterialService: TipoMaterialService,
    private service: PedidoService,
    private datePipe: DatePipe,
    private comunidadService: ComunidadService
    ) {}

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.COMPRAS_LIST).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result)
        this.loadView();
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;
    this.buildForm();

    this.getTipoMaterial();
    this.getAutocompleteComunidadeOrigen();
    this.getAutocompleteComunidadeDestino();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.menuService.checkMenu(MenuFuncionCodes.PEDIDO_EDIT).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result)
        this.canEdit = true;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  displayComunidad(comunidad: Comunidad): string {
    var displayWith = this.sharedFunctions.formatComunidadName(comunidad);
    return displayWith;
  }

//#region forms

  buildForm() {
    var estadosList = [
      EstadoConstants.ESTADO_PEDIDO_PENDIENTE_PRESUPUESTO,
      EstadoConstants.ESTADO_PEDIDO_PENDIENTE_COORDINACION,
      EstadoConstants.ESTADO_PEDIDO_ENTREGADO
    ];

    this.searchForm = this.formBuilder.group({
      'TipoMaterialId': [0],
      'PedidoId': [null],
      'ComunidadOrigen': [null],
      'ComunidadDestino': [null],
      'Estados': [estadosList],
      'FechaNecesidadDesde': [null],
      'FechaNecesidadHasta': [null],
      'FiltroFacturado': [0]
    });
  }

//#endregion

//#region getters
  getTipoMaterial() {
    var r = new SearchTipoMaterialRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoMaterialSearching = true;

    this.tipoMaterialService.search(r).subscribe(data => {
      this.isTipoMaterialSearching = false;
      this.tipoMaterialList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMaterialSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAutocompleteComunidadeOrigen() {
    this.searchForm.get("ComunidadOrigen")?.valueChanges
    .pipe(
    filter(res => {
        return res && res !== null && res.length >= 3
    }),
    distinctUntilChanged(),
    debounceTime(1000),
    tap(() => {
        this.filteredComunidadesList = [];
        this.isComunidadSearching = true;
    }),
    switchMap(value => this.comunidadService.search(new SearchComunidadRequest(50, null, true, "Nombre", !isNumber(parseInt(value)) ? value : "", null, null, null, null, true))
        .pipe(
        finalize(() => {
            this.isComunidadSearching = false;
        }),
        )
    )
    )
    .subscribe((data: any) => {
        if (data != null && data.result != null)
            this.filteredComunidadesList = data.result;
        else
            this.filteredComunidadesList = [];
    });
  }

  getAutocompleteComunidadeDestino() {
    this.searchForm.get("ComunidadDestino")?.valueChanges
    .pipe(
    filter(res => {
        return res && res !== null && res.length >= 3
    }),
    distinctUntilChanged(),
    debounceTime(1000),
    tap(() => {
        this.filteredComunidadesList = [];
        this.isComunidadSearching = true;
    }),
    switchMap(value => this.comunidadService.search(new SearchComunidadRequest(50, null, true, "Nombre", !isNumber(parseInt(value)) ? value : "", null, null, null, null, true))
      .pipe(
        finalize(() => {
            this.isComunidadSearching = false;
        }),
      )
    ))
    .subscribe((data: any) => {
      if (data != null && data.result != null)
        this.filteredComunidadesList = data.result;
      else
        this.filteredComunidadesList = [];
    });
  }

//#endregion

//#region grid
  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "TipoMaterialId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoMaterialId;
    else
      this.query.addParams("TipoMaterialId",this.searchForm.value.TipoMaterialId);

    index = this.query.params.findIndex(obj => obj.key === "PedidoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PedidoId;
    else
      this.query.addParams("PedidoId", this.searchForm.value.PedidoId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadOrigenId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadOrigen?.Id;
    else
      this.query.addParams("ComunidadOrigenId", this.searchForm.value.ComunidadOrigen?.Id);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadDestinoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadDestino?.Id;
    else
      this.query.addParams("ComunidadDestinoId", this.searchForm.value.ComunidadDestino?.Id);

    index = this.query.params.findIndex(obj => obj.key === "FiltroFacturado");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.FiltroFacturado;
    else
      this.query.addParams("FiltroFacturado", this.searchForm.value.FiltroFacturado);

    index = this.query.params.findIndex(obj => obj.key === "Estados");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Estados?.join(",");
    else
      this.query.addParams("Estados", this.searchForm.value.Estados?.join(","));
  }
//#endregion

//#region actions
  add() {
    this.router.navigate(['pedido-edit', 0]);
  }

  edit(item: Pedido) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['pedido-edit', item.Id]);
  }

  onExport() {
    var search = new SearchPedidoRequestDto(null, null, null, "", null, null, null, null, null, this.verSoloActivos, 0, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Pedidos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
//#endregion
}
